import { useState } from "react";
import css from "./Food.module.css";
import check from "./check.png";

const Steps = ({ children, img }) => {
  const [checked, setChecked] = useState(false);

  return (
    <div
      className={`${css.steps_container} ${checked ? css.steps_container_checked : ""} ${img ? css.steps_img : ""}`}
      onClick={() => setChecked((current) => !current)}
    >
      <div className={css.steps}>
        <button className={`${css.checkbox} ${checked ? css.checked : ""}`}>
          {checked && (
            <img src={check} alt="a check mark" className={css.check} />
          )}
        </button>
        <div
          className={`${css.step_list} ${checked ? css.step_list_checked : ""}`}
        >
          {children}
        </div>
      </div>
      {img && <img className={css.img} src={img.src} alt={img.alt} />}
    </div>
  );
};

export default Steps;
